// src/api/contactFormService.ts
import { ContactFormCreate, ContactFormResponse, ScanReportRequest, ScanReportResponse } from '../types/interfaces';
import apiClient from './config';

export const submitContactForm = async (
  formData: ContactFormCreate
): Promise<ContactFormResponse> => {
  const response = await apiClient.post<ContactFormResponse>('/contact', formData);
  return response.data;
};

export const submitScanReportRequest = async (
  data: ScanReportRequest
): Promise<ScanReportResponse> => {
  try {
    const response = await apiClient.post<ScanReportResponse>('/contact/report-email', data);
    return response.data;
  } catch (error: any) {
    return {
      error: error.response?.data?.error
    };
  }
};